
const pricing = (() => {

  const volOnlyMin = 8_125;

  const pricePoints = [
    {cap:    100, price:  8_125, addonStrength: 0.15},
    {cap:    150, price:  8_375, addonStrength: 0.25},
    {cap:    200, price:  8_625, addonStrength: 0.40},
    {cap:    250, price:  8_875, addonStrength: 0.55},
    {cap:    300, price:  9_125, addonStrength: 0.70},
    {cap:    350, price:  9_375, addonStrength: 0.85},
    {cap:    400, price:  9_625, addonStrength: 0.90},
    {cap:    450, price:  9_875, addonStrength: 0.95},
    {cap:    500, price: 10_145},
    {cap:    600, price: 11_472},
    {cap:    700, price: 12_376},
    {cap:    800, price: 13_264},
    {cap:    900, price: 13_905},
    {cap:  1_000, price: 14_680},
    {cap:  1_250, price: 16_125},
    {cap:  1_500, price: 17_175},
    {cap:  1_750, price: 18_638},
    {cap:  2_000, price: 20_100},
    {cap:  2_500, price: 23_200},
    {cap:  3_000, price: 26_340},
    {cap:  3_500, price: 29_120},
    {cap:  4_000, price: 31_200},
    {cap:  4_500, price: 34_515},
    {cap:  5_000, price: 37_650},
    {cap:  5_500, price: 40_590},
    {cap:  6_000, price: 43_440},
    {cap:  6_500, price: 46_020},
    {cap:  7_000, price: 48_580},
    {cap:  8_000, price: 54_400},
    {cap:  9_000, price: 60_030},
    {cap: 10_000, price: 65_300},
    {cap: 15_000, price: 85_500},
    {cap: 20_000, price: 93_000},
  ];

  const percents = {
    intl:       0.10,
    vol:        0.30,
    volNoMatch: 0.80,
    groups:     0.25,
    analytics:  0.20,
    sso:        0.10,
    payroll:    0.20,
  };

  const getPrice = (empCount=0, {match=false, intl=false, vol=false, groups=false, analytics=false, sso=false, payroll=false, contactUs=true} = {}) => {
    if ((empCount > 10000) && contactUs) return null;

    const pricePoint = pricePoints.find(mp => mp.cap >= empCount);
    if (!pricePoint) return null;
    const addonStrength = pricePoint.addonStrength || 1;
    const basePrice = pricePoint.price;
    const priceFromPercent = (percentage) => Math.round(basePrice * percentage * addonStrength);

    const hasMatch = !!(match || intl);
    const volPercentage = hasMatch ? percents.vol : percents.volNoMatch;

    const matchPrice     = hasMatch  ? basePrice                            : 0;
    let   volPrice       = vol       ? priceFromPercent(volPercentage)      : 0;
    const intlPrice      = intl      ? priceFromPercent(percents.intl)      : 0;
    const groupsPrice    = groups    ? priceFromPercent(percents.groups)    : 0;
    const analyticsPrice = analytics ? priceFromPercent(percents.analytics) : 0;
    const ssoPrice       = sso       ? priceFromPercent(percents.sso)       : 0;
    const payrollPrice   = payroll   ? priceFromPercent(percents.payroll)   : 0;
    // enforce minimum on vol-only
    if (!hasMatch && vol && (volPrice < volOnlyMin)) {
      volPrice = volOnlyMin;
    }
    const totalPrice = [matchPrice, intlPrice, volPrice, groupsPrice, analyticsPrice, ssoPrice, payrollPrice].reduce((acc, price) => acc + price, 0);

    return {
      match: matchPrice,
      intl: intlPrice,
      vol: volPrice,
      groups: groupsPrice,
      analytics: analyticsPrice,
      sso: ssoPrice,
      payroll: payrollPrice,
      total: totalPrice,
    };
  };

  const format = (dollarInt) => {
    return `$${dollarInt.toLocaleString('en-US')}`;
  };

  return {
    getPrice,
    format,
    pricePoints,
  };

})();

export default pricing;
